module.exports = __webpack_public_path__ + "img/bigscreen.39b19265.jpg";